export default (value: string, min: number): boolean => value.length < min
